var _path, _path2, _path3, _path4, _path5, _path6, _mask, _g, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyStateVendors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 275,
    viewBox: "0 0 249 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.677 103.313L215.272 131.504V230.148L112.677 185.949V103.313Z",
    fill: "#8E99A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.794 103.41L29 126.825V230.479L112.794 185.614V103.41Z",
    fill: "#A0AAB5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M166.763 223.082C143.609 216.304 102.945 216.909 87.6736 177.298C73.6778 140.994 125.307 106.054 139.751 121.351C149.987 132.191 136.867 147.823 118.662 146.067C98.1702 144.09 86.0578 125.765 90.0982 106.054C98.113 66.9543 159.733 41.0852 162.331 39.2832",
    stroke: "url(#paint0_linear)",
    strokeWidth: 3,
    strokeDasharray: "6 7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.659 26.6326C168.659 26.6326 168.077 11.9308 164.184 8.03772C160.291 4.14468 153.974 4.14971 150.075 8.04894C146.176 11.9482 146.171 18.2651 150.064 22.1581C153.957 26.0511 168.659 26.6326 168.659 26.6326Z",
    fill: "#CED8E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.49 32.5178C175.49 32.5178 176.072 47.2196 179.965 51.1127C183.858 55.0057 190.175 55.0007 194.074 51.1014C197.973 47.2022 197.978 40.8853 194.085 36.9923C190.192 33.0993 175.49 32.5178 175.49 32.5178Z",
    fill: "#CED8E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M163.877 28.1313C163.877 23.6577 167.503 20.0312 171.977 20.0312H181.123V29.15C181.123 33.6235 177.497 37.25 173.023 37.25H163.877V28.1313Z",
    fill: "#A8B7C5"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 163,
    y: 20,
    width: 19,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.877 28.1313C163.877 23.6577 167.503 20.0312 171.977 20.0312H181.123V29.15C181.123 33.6235 177.497 37.25 173.023 37.25H163.877V28.1313Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.858,
    y: 24.8201,
    width: 2.72308,
    height: 19.9375,
    transform: "rotate(-45 160.858 24.8201)",
    fill: "#DDE5F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.304 20.2888L168.229 18.3633L182.327 32.4612L180.402 34.3867L166.304 20.2888Z",
    fill: "#DDE5F2"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M190.383 15.7171L197.008 14.1406",
    stroke: "#8696C5",
    strokeWidth: 0.9
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M187.66 12.9983L190.209 6.44116",
    stroke: "#8696C5",
    strokeWidth: 0.9
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.846 25.4688C187.857 25.4688 191.108 22.2228 191.108 18.2188C191.108 14.2147 187.857 10.9688 183.846 10.9688C179.836 10.9688 176.585 14.2147 176.585 18.2188C176.585 22.2228 179.836 25.4688 183.846 25.4688Z",
    fill: "#8B9AA8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 127.012L131.595 159.569V274.534L29 230.335V127.012Z",
    fill: "#DAE2EC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.789 131.377L130.14 159.568V274.533L215.789 230.335V131.377Z",
    fill: "#C5D0D9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.547 131.31L248.657 175.62L160.789 210.248L130.442 159.351L215.547 131.31Z",
    fill: "#DAE2EC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8764 126.772L0.197815 171.51L101.274 210.248L130.804 159.29L28.8764 126.772Z",
    fill: "#C5D0D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 103.757,
    y1: 17.3576,
    x2: 31.3323,
    y2: 52.4596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateVendors);
export default __webpack_public_path__ + "static/media/empty-state-vendors.34f707869b3de507b151541c95a03e6e.svg";
export { ForwardRef as ReactComponent };